import { CourseSchedulerConstant } from '../../views/course_scheduler/constants/course_scheduler_constants';
import { ISectionRegistrationAttributesDatasource } from '../datasources/section_registration_attributes_datasource';
import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';

export type StoreRegistrationAttributeValuesCommand = () => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'storeRegistrationAttributeValuesCommand',
    (
      defineCommand: IDefineCommand,
      ngSectionRegistrationAttributesDatasource: ISectionRegistrationAttributesDatasource
    ) =>
      defineCommand('storeRegistrationAttributeValuesCommand', (deferred) => {
        const formElement = document.querySelector(`#${CourseSchedulerConstant.scheduledSectionFormId}`);
        if (!formElement) {
          deferred.resolve();
          return;
        }
        const sectionAttributes = ngSectionRegistrationAttributesDatasource.read();
        _4.forEach(sectionAttributes, (sectionAttribute) => {
          sectionAttribute.attributes.forEach((attribute) => {
            const element = formElement.querySelector(`[name='${attribute.name}']`);
            if (!element) {
              return;
            }
            const selectedValues = !_4.isEmpty(element['values']) ? _4.toArray(element['values']) : [];
            const initialValue = !_4.isEmpty(selectedValues) ? selectedValues : element['value'];

            attribute.initial_value = initialValue;
          });
        });
        ngSectionRegistrationAttributesDatasource.write(sectionAttributes);
        deferred.resolve();
      })
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/registration_attributes/commands/store_registration_attribute_values_command.ts